
import React from "react";
import BaseLayout from "../../components/layout/BaseLayout";
import { useRouter } from "next/router";
import ProbeInput from "../../components/probe/ProbeInput";
import Link from "next/link";
import TextContainer from "../../components/layout/TextContainer";
import { ProbeRunnerProvider } from "../../components/probe/ProbeFunctionProvider";
import PageHeader from "../../components/general/PageHeader";
import AuthGuard from "../../components/auth/AuthGuard";
import ActionButton from "../../components/general/ActionButton";


export default function OptimizeRoutes() {

  return (
    <BaseLayout
      pageTitle="Probe the network, reveal fees"
      disableOnMaintenance={true}
    >
      <PageHeader
        title="Network probe"
        description="Find paths and fees between two nodes."
      />

      <div className="flex flex-col items-center h-full mb-16 py-12">
        <p className="text-center bg-viking-500 px-12 py-1  font-black italic">Network probe has been discontinued.</p>
      </div>

      {/* <AuthGuard mustBe="authenticated">
        <div>
          <ProbeRunnerProvider>
            <ProbeInput />
          </ProbeRunnerProvider>
        </div>
      </AuthGuard> */}

      {/* <AuthGuard mustBe="unauthenticated">
        <div className="flex flex-col items-center h-full mb-16 py-12">
          <p className="text-center bg-viking-500 px-12 py-1  font-black italic">Network probe requires authentication.</p>

          <div className="mt-8">
            <Link href="/auth/login">
              <a>
                <ActionButton className="">
                  <span className="text-lg">
                    Sign up
                  </span>
                </ActionButton>
              </a>
            </Link>

          </div>
        </div>
      </AuthGuard> */}

      <TextContainer className="mt-12 text-lg">
        <div className="text-center">
          <p className="font-bold text-base text-gray-600 mt-16 pb-2"><span className="">Or have a look at one of these examples</span></p>
          <ul className=" pl-8">
            <li>
              <a className="underline" href="https://lnrouter.app/probe/report?n=bfx-lnd0-YTMND&id=KNSG9nZ2GIl6mViQmGHDj">
                Bitfinex to YTMND
              </a>
            </li>
            <li>
              <a className="underline" href="https://lnrouter.app/probe/report?n=Satoshis.G-037cc5f9f1&id=jeG-mAyG761zxvyAeiLur">
                Satoshis.Games to BlueWallet
              </a>
            </li>
            <li>
              <a className="underline" href="https://lnrouter.app/probe/report?n=OpenNode.c-southxchan&id=mlLznP7pL6u_0WpY4cTAz">
                Opennode.com to Southxchange
              </a>
            </li>
            <li>
              <a className="underline" href="https://lnrouter.app/probe/report?n=CoinsOfNak-magnetron&id=kKeSGP_XAO1T--8Nzn91W">
                CoinsOfNakamoto.com to magnetron
              </a>
            </li>
          </ul>
        </div>

        <div className="mt-32">
          <h2 className="text-xl font-bold mb-2 text-gray-800"><span className="">What can you do with it?</span></h2>
          <ul className="list-disc pl-8">
            <li>Checkout the routing fees between nodes and optimize your own fees.</li>
            <li>Find new profitable routes that have high fees.</li>
          </ul>
        </div>



        <div className="mt-12">
          <h2 className="text-xl font-bold mb-2 text-gray-800"><span className="">How does it work</span></h2>
          <p>
            LnRouter probes routes in the Lightning Network between the source and target node
            to figure out routes that actually work. The resulting report shows you exactly what fees are paid between the nodes.
          </p>
          <h2 className="font-bold text-base text-gray-600 mt-8 pb-2">What is a probe?</h2>
          <p>
            A probe is a test payment that doesn't actually send funds.
            A successful probe reveals if a route between nodes is actually working and gives a hint, how much money
            it is able to transact*.
          </p>

          <p>See <a href="https://medium.com/blockstream/c-lightning-plugins-02-the-probe-plugin-bb92b7fd8cc3"
            className="underline" target="_blank">
            here</a> for more information about probing.
          </p>

          <h2 className="font-bold text-base text-gray-600 mt-8 pb-2">How is it different to Shortest Path?</h2>
          <p>
            <span className="underline"><Link href="/get-route">Shortest Path,</Link></span> like other query route tools
            (<span className="italic">Ride the Lightning, <span className="code">lightning-cli getroute</span>, <span className="code">lncli queryroutes</span></span>),
            does not check if the channels on the actual route are balanced and therefore work. The probing algorithm actually
            sends a test payment to the node to make sure the payment is successful.
          </p>

          <h2 className="font-bold text-base text-gray-600 mt-8 pb-2">Why is the newly created report not up to date?</h2>
          <p>
            LnRouter utilises heavy caching to reduce the load on the network. If the algorithm encounters a non-working channel
            the channel will be excluded for 24 hours. This might influence the accuracy of the report.
          </p>

        </div>
      </TextContainer>
    </BaseLayout>
  );
}
